import { brand, sitemapGroups } from "@/mocks/homeData";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-secondary-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-secondary-950">
                <i className="ri-radar-line text-lg" />
              </span>
              <span className="font-heading font-bold text-xl">{brand.name}</span>
            </div>
            <p className="mt-4 font-body text-sm leading-relaxed text-secondary-100/85 max-w-sm">
              娱乐八卦、网络热点与影视综动态的频道导航门户。把分散的栏目整理成清晰的入口，
              让你几秒内找到想看的内容。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-secondary-100">
                <i className="ri-mail-line" />
              </span>
              <a
                href={`mailto:${brand.email}`}
                className="font-label text-sm text-secondary-50 hover:text-accent-300 cursor-pointer"
              >
                {brand.email}
              </a>
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            {sitemapGroups.map((group) => (
              <div key={group.title}>
                <h4 className="font-label text-sm font-bold text-accent-300 mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={`${group.title}-${link.label}`}>
                      <a
                        href={link.href}
                        className="font-body text-sm text-secondary-100/80 hover:text-accent-200 cursor-pointer transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-label text-xs text-secondary-100/70 text-center sm:text-left">
            © {year} {brand.name} · {brand.slogan} · 本站内容为公开信息的整理与索引
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#sitemap"
              className="font-label text-xs text-secondary-100/80 hover:text-accent-200 cursor-pointer"
            >
              站点地图
            </a>
            <a
              href="#about"
              className="font-label text-xs text-secondary-100/80 hover:text-accent-200 cursor-pointer"
            >
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}